import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { resultsSelector } from '../../../../../selectors/commonSelectors';

type YMEventsCenterProps = {
  ymCounterId: number;
};

/**
 * @description Центр отправки событий в Яндекс.Метрику
 */
export const YMEventsCenter: FC<YMEventsCenterProps> = props => {
  const { ymCounterId } = props;

  const results = useSelector(resultsSelector);

  useEffect(() => {
    /**
     * @description Отправка события в Яндекс.Метрику. Отправляем каждый раз, когда получаем новые данные по выдаче,
     * именно по этому мы выбираем results из стора, а не конкретное поле
     */

    const ymPriceChangeEventData = results.ymEvents?.onPriceChange;

    if (ymPriceChangeEventData && ym) {
      ym(ymCounterId, ymPriceChangeEventData.eventName, ymPriceChangeEventData.target);
    }
  }, [ymCounterId, results]);

  return null;
};
